/* istanbul ignore file */

export const FORM_CONSTANTS = {
    DEFAULT_MAX_COLUMNS: 5,
    AVAILABLE_FIELDS_DROP_LIST_PREFIX: 'kh-available-fields-',
    COLUMN_FIELDS_DROP_LIST_PREFIX: 'kh-column-fields-',
    COLUMN_ROW_DROP_LIST_PREFIX: 'kh-column-row-'
};
